import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UtilityService } from '../utility.service';
import { TravelReimbursementView } from 'app/models/form/TravelReimbursementView';
import { BaseFormService } from '../BaseFormService';

@Injectable({
	providedIn: 'root',
})
export class TravelReimbursementPaymentService extends BaseFormService {
	constructor(httpClient: HttpClient, utilityService: UtilityService) {
		super(
			`${environment.apiUrl}travel-reimbursement/clients/$$clientId$$/forms/travel-reimbursement-payment-form`,
			httpClient,
			utilityService
		);
	}

	createForm(clientId: string, request: any): Observable<any> {
		const formData: FormData = new FormData();
		formData.append('model', JSON.stringify(request));
		return this.httpClient.post<any>(`${this.getUrl(clientId)}`, formData).pipe();
	}

	updateForm(clientId: string, id: string, request: any): Observable<any> {
		const formData: FormData = new FormData();
		formData.append('model', JSON.stringify(request));
		return this.httpClient.put<any>(`${this.getUrl(clientId)}/${id}`, formData).pipe();
	}

	getAllForms(clientId: string, request: any): Observable<any[]> {
		return this.httpClient.post<any[]>(`${this.getUrl(clientId)}/all`, request).pipe();
	}

	deleteExpense(clientId: string, formId: string, id: string): Observable<TravelReimbursementView> {
		return this.httpClient.delete<TravelReimbursementView>(`${this.getUrl(clientId)}/statements/${id}`).pipe();
	}
	submitForApproval(clientId: string, id: any, userId: string): Observable<TravelReimbursementView> {
		return this.httpClient
			.post<TravelReimbursementView>(`${this.getUrl(clientId)}/${id}/approval`, {
				userId,
			})
			.pipe();
	}
	updateAutoPay(clientId: string, formId: string, autoPay: boolean): Observable<any> {
		return this.httpClient.patch(`${this.getUrl(clientId)}/${formId}/autopay`, autoPay).pipe();
	}
}
